export enum SPECIALTY {
  PSYCHOLOGIST = 'PSICOLOGO',
  PSYCHOLOGIST_PV = 'PSICOLOGO_VIVA',
}
